

function playVideoHtml5(videoElement) {
    videoElement.play();

    videoElement.addEventListener('play', function () {
        videoElement.parentElement.setAttribute('data-status', 'play');
    });
    videoElement.addEventListener('pause', function () {
        videoElement.parentElement.setAttribute('data-status', 'pause');
    });
}

document.querySelectorAll('.media-video-html5').forEach(function (mediaVideoHtml5) {
    let videoElement = mediaVideoHtml5.querySelector('video');

    mediaVideoHtml5.querySelector('button').addEventListener('click', function () {
        playVideoHtml5(videoElement);
    });
    if (videoElement.hasAttribute('autoplay')) {
        playVideoHtml5(videoElement);
    }
});